(function() {
  'use strict';
  angular.module('ringbaPortal').directive('multiSelect', multiSelect);

  function multiSelect(

  ) {
    'ngInject';

    const directive = {
      restrict: 'E',
      require: ['multiSelect', '^ngModel'],
      scope: {
        optionsList: '<',
        optionValueProperty: '@', // property of object to be shown as the value
        optionDisplayProperty: '@',
        selectedListSearchLabel: '@',
        optionsListSearchLabel: '@',
        selectObject: '<',
        placeholder: '@',
        showSelectAll: '<'
      },
      link: link,
      templateUrl: '/scripts/shared/directives/multi-select/multi-select.view.html',
      replace: true,
      controller: 'MultiSelectController',
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;

    function link(scope, element, attributes, controllers) {
      const $multiSelectCtrl = controllers[0],
        ngModelCtrl = controllers[1];

      $multiSelectCtrl.setNgModelController(ngModelCtrl);
    }
  }

})();
